import {
  resourceReducer,
} from 'redux-resource';
import {
  selection,
  includedResources,
} from 'redux-resource-plugins';

import {
  allListPlugin,
  multiListPlugin,
  customListPlugin,
} from './plugins';

export default resourceReducer('workoutExercises', {
  initialState: {
    ...selection.initialState,
  },
  plugins: [
    selection,
    includedResources,
    multiListPlugin,
    customListPlugin,
    allListPlugin,
  ],
});
